module.exports = __webpack_public_path__ + "img/1.d100db34.png";